import { motion } from "framer-motion";
import { PhoneMissed, MessageSquareText } from "lucide-react";

const IMG =
  "https://static.prod-images.emergentagent.com/jobs/51ddf5f6-e80c-4259-9ef6-c5393e7b5903/images/96ad74e84e8c52564f896e49379d149678f852c03018e46ce97f32654d19d499.png";

export default function MissedCallFollowup() {
  return (
    <section
      data-testid="missed-call-section"
      aria-labelledby="missed-call-heading"
      className="relative bg-mist-soft py-20 sm:py-24"
    >
      <div className="container-page grid grid-cols-1 items-center gap-12 lg:grid-cols-12 lg:gap-14">
        <motion.div
          initial={{ opacity: 0, x: -16 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.55, ease: "easeOut" }}
          className="order-2 lg:order-1 lg:col-span-6"
        >
          <div className="relative">
            <div className="overflow-hidden rounded-3xl border border-mist-line bg-white shadow-lift">
              <img
                src={IMG}
                alt="Illustration of a missed call follow-up: a phone screen showing a friendly automated SMS sent to the homeowner."
                className="h-full w-full object-cover"
                loading="lazy"
              />
            </div>

            {/* faux SMS callout */}
            <div className="absolute -bottom-5 left-4 hidden max-w-xs rotate-[-2deg] rounded-2xl border border-mist-line bg-white p-4 shadow-lift sm:block sm:-bottom-7 sm:left-8">
              <div className="flex items-start gap-3">
                <span className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-aqua/15 text-aqua-deep">
                  <MessageSquareText className="h-4 w-4" />
                </span>
                <div className="leading-tight">
                  <p className="text-[10px] font-semibold uppercase tracking-[0.16em] text-navy/55">
                    Auto-reply
                  </p>
                  <p className="mt-1 text-[13px] text-navy">
                    &ldquo;Hi! Sorry we missed you &mdash; tap here to tell us
                    what&rsquo;s happening with your AC and we&rsquo;ll get
                    right back.&rdquo;
                  </p>
                </div>
              </div>
            </div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 16 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.55, ease: "easeOut" }}
          className="order-1 lg:order-2 lg:col-span-6"
        >
          <span className="pill">
            <PhoneMissed className="h-3 w-3 text-sun" />
            Missed-call follow-up
          </span>
          <h2
            id="missed-call-heading"
            className="mt-4 font-display text-3xl font-bold leading-tight tracking-tight text-navy sm:text-4xl lg:text-[2.5rem]"
          >
            Missed a call? The system can keep the lead warm.
          </h2>
          <p className="mt-4 max-w-xl text-base text-navy/70 sm:text-lg">
            If a homeowner calls while the office is busy, the system can send
            a follow-up text and collect the details needed for a callback. No
            leads slip through the cracks.
          </p>
          <div className="mt-6 inline-flex items-center gap-2 rounded-full border border-mist-line bg-white px-3 py-1.5 text-xs font-medium text-navy/65">
            <span className="h-1.5 w-1.5 rounded-full bg-sun" />
            Demo concept &mdash; PrismForge Digital builds these workflows for
            contractors.
          </div>
        </motion.div>
      </div>
    </section>
  );
}
